import API from './API';
import URLSearchParams from 'url-search-params';
import SearchActions from 'actions/SearchActions';

const SearchSource= {
  searchRemoteProducts: {
    remote(state) {
      const fetchUrl = API.getProductSearch;
      const searchParams = new URLSearchParams();
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);
      searchParams.append('key', state.keyword);
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: SearchActions.fetchSuccess,
    error: SearchActions.fetchError
  },
  searchRemoteMedias: {
    remote(state) {
      const fetchUrl = API.getMediaSearch;
      const searchParams = new URLSearchParams();
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);
      searchParams.append('key', state.keyword);
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: SearchActions.fetchSuccess,
    error: SearchActions.fetchError
  },
  searchRemoteAlbums: {
    remote(state) {
      const fetchUrl = API.getAlbumSearch;
      const searchParams = new URLSearchParams();
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);
      searchParams.append('key', state.keyword);
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: SearchActions.fetchSuccess,
    error: SearchActions.fetchError
  },
  searchRemoteFeatures: {
    remote(state) {
      const fetchUrl = API.getFeatureSearch;
      const searchParams = new URLSearchParams();
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);
      searchParams.append('key', state.keyword);
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: SearchActions.fetchSuccess,
    error: SearchActions.fetchError
  },
  searchRemoteUsers: {
    remote(state) {
      const fetchUrl = API.getUserSearch;
      const searchParams = new URLSearchParams();
      searchParams.append('first', state.first);
      searchParams.append('maxCount', state.maxCount);
      searchParams.append('key', state.keyword);
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: SearchActions.fetchSuccess,
    error: SearchActions.fetchError
  }
};

export default SearchSource;



// WEBPACK FOOTER //
// ./src/sources/SearchSource.js